import { SET_BRANCH_INFO } from '../actions/branchAction';

const INITIAL_STATE = {
  branchInfo: {
    addrUpdateEnabled: null,
    basicDeliveryPrice: null,
    branchCode: null,
    branchName: null,
    delayPickupTime: null,
    deleteDate: null,
    deleted: null,
    deliveryEnabled: null,
    deliveryStatShow: null,
    distShowSetting: null,
    dwServiceType: null,
    endTime: null,
    extCode: null,
    idx: null,
    latitude: null,
    longitude: null,
    mapUrl: null,
    maxDeliveryFee: null,
    monthBasicAmount: null,
    pickupAvTime0: null,
    pickupAvTime5: null,
    pickupAvTime5After: null,
    pickupAvTime10: null,
    pickupAvTime10After: null,
    pickupAvTime15: null,
    pickupAvTime15After: null,
    pickupAvTime20: null,
    pickupAvTime20After: null,
    pickupAvTime25: null,
    pickupAvTime25After: null,
    pickupAvTime30: null,
    pickupAvTime35: null,
    pickupAvTime40: null,
    pickupAvTime45: null,
    pickupAvTime50: null,
    pickupAvTime55: null,
    pickupAvTime60: null,
    pickupAvTime70: null,
    riderCancelPenalty: null,
    showCount: null,
    startDate: null,
    startTime: null,
    tel: null,
  },
};

const branchReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BRANCH_INFO:
      return Object.assign({}, state, { branchInfo: action.branchInfo });

    default:
      return state;
  }
};

export default branchReducer;
